module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_WYCIAG_Z_KONTA.ef466409.mp3";